module.exports = __webpack_public_path__ + "img/earnings.5fb9123e.svg";